import React from 'react';
import { Box } from '@mui/material';
import WidenConfig from '../components/WidenConfig';

// Full-width settings page wrapper for Widen configuration
const WidenSettingsPage: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: 'calc(100vh - 64px)',
        px: 3,
        py: 3,
        overflowX: 'hidden',
        // Force children to span full available width
        '& .MuiCard-root': {
          width: '100%',
        },
        '& .MuiBox-root': {
          maxWidth: 'none',
        },
      }}
    >
      <WidenConfig />
    </Box>
  );
};

export default WidenSettingsPage;


